module.exports = __webpack_public_path__ + "media/images/flags/16/Japan-afb1725b2205afa48b0aecfe03e25164.png";